import { useEffect, useContext, useRef } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { unique } from '../productListHelper';

export const useProducts = ({ setProductData, setLoadedItemIds, loadedItemIds }) => {
  const { storeId, storeZip } = useStore({ varnish: true });
  const { getDeliveryZipCookie } = podFulFillmentUtils;
  const deliveryZip = getDeliveryZipCookie();
  const itemsBeingFetched = useRef([]);
  const [fetchData, productsResponse] = useLazyDataModel('products', {
    variables: {
      storeId,
      zipCode: deliveryZip || storeZip
    },
    ssr: false,
    context: { withAuth: true },
  });

  const {
    data: productInfoData,
    loading: productInfoLoading,
    error,
    variables: productsVariables,
  } = productsResponse || {};

  useEffect(() => {
    const { products } = productInfoData || {};
    if (products?.length || error?.graphQLErrors?.length) {
      const productsData = productsVariables?.itemIds.map((itemId) => {
        const loadedProductData = (products || []).find((product) => product.itemId === itemId) || {};
        return {
          ...loadedProductData,
          itemId,
          price: loadedProductData?.pricing?.value
        };
      });
      if (setProductData) {
        setProductData((prevData) => {
          return [...prevData, ...productsData];
        });
      }
      setLoadedItemIds((prevData) => {
        return [...prevData, ...itemsBeingFetched.current];
      });
    }
  }, [productInfoData]);

  const isAlreadyLoadedItems = (items) => {
    return items.every((item) => {
      const productKey = item.itemId || item.omsId || item.id;
      return loadedItemIds.includes(productKey);
    });
  };

  const fetchProducts = async (items) => {
    const itemIdsToFetch = items.map((item) => item.itemId || item.omsId || item.id)
      .filter((id) => id !== null)
      .filter(unique);
    const itemsBeingFetchedNow = items.map((item) => item.itemId || item.omsId || item.id);
    if (itemIdsToFetch.length === 0) {
      setLoadedItemIds((prevData) => {
        return [...prevData, ...itemsBeingFetchedNow];
      });
      itemsBeingFetched.current = [];
    } else if (
      !isAlreadyLoadedItems(items)
      && itemsBeingFetched.current.join() !== itemsBeingFetchedNow.join()
    ) {
      itemsBeingFetched.current = itemsBeingFetchedNow;
      return fetchData({
        variables: {
          itemIds: itemIdsToFetch
        }
      });
    }
    return null;
  };

  return {
    fetchProducts,
    productInfoData,
    productInfoLoading,
    error,
    productsVariables
  };
};
